import styled from "styled-components";

const MainSection = styled.div`
    .error-occured {
        height: 100vh;
        padding: 20px;
        .inner {
            min-height: 200px;
            width: 400px;
            background-color: #efefef;
            padding: 15px;
            border-radius: 5px;
        }

        .icon {
            font-size: 30px;
        }
    }
`;
export default MainSection;
